<script setup lang="ts">
import { watch } from 'vue';
import { VApp } from 'vuetify/components';
console.log('Create APP')
import { useStore } from './store/index'
const store = useStore();
const route = useRoute()
const headers = useRequestHeaders()

const compAppClass = computed(()=>{
  if (store.ModoAccesible){
    return 'accesible-mode';
  }
  return '';
});
console.log('useAsyncData initNotaria');
const id = await useAsyncData("initNotaria", ()=>store.initNotaria(headers, route).then(() => true));





function createHead(){
  const notaryLogo = store.NOTARIA?.Theme?.Home?.Banner?.ImagenLogo;
  const faviconUrl = notaryLogo ? `https://${store.host}/appdata/static/${notaryLogo}` : '/favicon.ico';

  let head: any = {
    titleTemplate: (titleChunk: string) => {
      const notaryName = store.NOTARIA?.Nombre || 'Notaría';
      return titleChunk ? `${titleChunk} | ${notaryName}` : notaryName;
    },
    link: [
      { rel: 'icon', type: 'image/x-icon', href: faviconUrl }
    ]
  }
  if(store.css_list){
    store.css_list.forEach(css =>{
      head.link.push({ rel: 'stylesheet', href: css })
    })
  }
  return head
}
useHead(createHead())

// Vigilancia reactiva para manejar la página de construcción
watch([() => store.token, () => route.path, () => store.NOTARIA], ([newToken, newPath, newNotaria]) => {
  if (!newNotaria) return;
  
  const isUnderConstActive = newNotaria.Personalizar?.UnderConstruction;
  const isOnUnderConstPage = newPath.toLowerCase().includes('underconstruction');

  // Si hay token y estamos en la página de construcción, salir de ahí YA
  if (newToken && isOnUnderConstPage) {
    return navigateTo("/");
  }

  // Si no hay token y la página está activa, ir a construcción
  if (isUnderConstActive && !newToken && !isOnUnderConstPage) {
    return navigateTo("/underconstruction");
  }
}, { immediate: true });

</script>
<template>
  <v-app id="app" :class="compAppClass">
    <NuxtLayout v-if="store.NOTARIA"/>
  </v-app>
</template>